import * as React from "react";
const SvgStatus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={31}
    height={30}
    fill="none"
    {...props}
  >
    <path
      stroke="#082B60"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2.25}
      d="M1.684 19.23c1.494 4.803 5.514 8.502 10.512 9.521M1.125 13.661c.712-7.05 6.659-12.536 13.89-12.536s13.178 5.5 13.89 12.536M17.821 28.765a13.99 13.99 0 0 0 10.512-9.464"
    />
  </svg>
);
export default SvgStatus;
